export function returnFuncIfServer<T extends (...args: any) => any>(
  func: T
): T | undefined {
  // We don't allow debouncing in SSR environments
  // eslint-disable-next-line @faire-web/no-restricted-globals
  return typeof window === "undefined" ? func : undefined;
}
